const formatAdventurerName = str => {
  var weirdApostrophe = /[\u2018-\u2019]/g; 

  return (str || '')
    .trimLeft()
    .split('') // split on all
    .map((l, i) => i === 0 ? l.toUpperCase() : l) // capitalise only the first letter
    .join('') // back to string
    .replace(weirdApostrophe, "'")
    .replace(/\s\s+/g, ' '); // Replace multiple spaces
};

module.exports = formatAdventurerName;

